import { API_URL } from "../../const";
import { Course, CourseMetaChunk } from "../../Models/Course";

// helper to handle responses
async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });

  if (!res.ok) {
    const msg = await res.text();
    throw new Error(msg || `Request failed: ${res.status}`);
  }

  return res.json();
}

// GET /api/v1/fetch-collections/
export async function listItems(): Promise<Course[]> {
  return request<Course[]>(API_URL + `/api/v1/fetch-collections/`);
}

// POST /api/v1/collections_meta/
export async function listItemsMetaChunk(
  collectionIds: number[]
): Promise<Record<number, Partial<Course>>> {
  return request<Record<number, Partial<Course>>>(
    API_URL + `/api/v1/collections_meta/`,
    {
      method: "POST",
      body: JSON.stringify({
        chunk: collectionIds,
      }),
    }
  );
}

export const listCourses = async () => {
  fetch(API_URL + `/api/v1/fetch-collections/`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(response.status.toString());
      }
    })
    .then((data) => {
      if (data != null) {
        return data;
      }
    })
    .catch((error) => {
      if (parseInt(error.message) === 403) {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.removeItem("userId");
        throw new Error("403");
      } else {
        throw new Error(error);
      }
    });
};
